import React from 'react';
export function ProblemStrip() {
  return <section className="w-full border-y border-white/[0.06] font-heading" style={{
    backgroundColor: '#0C0C0F'
  }} data-id="element-653">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center" data-id="element-654">
        {/* Headline */}
        <p className="text-xl md:text-2xl font-medium text-white/80 leading-relaxed" data-id="element-655">
          La gestion événementielle est encore fragmentée.
          <br className="hidden md:block" data-id="element-656" /> La plupart des organisations
          utilisent cinq outils pour faire ce qu'une seule plateforme devrait
          gérer.
        </p>

        {/* Pills */}
        <div className="mt-8 flex flex-wrap justify-center items-center gap-2 md:gap-3" data-id="element-657">
          <span className="bg-white/[0.06] border border-white/[0.10] rounded-full px-4 py-2 text-sm text-white/50 font-mono" data-id="element-658">
            Outil d'inscription
          </span>
          <span className="text-white/20 text-sm" data-id="element-659">+</span>
          <span className="bg-white/[0.06] border border-white/[0.10] rounded-full px-4 py-2 text-sm text-white/50 font-mono" data-id="element-660">
            PDF agenda
          </span>
          <span className="text-white/20 text-sm" data-id="element-661">+</span>
          <span className="bg-white/[0.06] border border-white/[0.10] rounded-full px-4 py-2 text-sm text-white/50 font-mono" data-id="element-662">
            Groupe WhatsApp
          </span>
          <span className="text-white/20 text-sm" data-id="element-663">+</span>
          <span className="bg-white/[0.06] border border-white/[0.10] rounded-full px-4 py-2 text-sm text-white/50 font-mono" data-id="element-664">
            Check-in manuel
          </span>
          <span className="text-white/20 text-sm" data-id="element-665">+</span>
          <span className="bg-white/[0.06] border border-white/[0.10] rounded-full px-4 py-2 text-sm text-white/50 font-mono" data-id="element-666">
            Rapport Excel
          </span>
        </div>

        {/* Arrow line */}
        <p className="mt-8 text-blue-400 font-medium text-lg" data-id="element-667">
          → MeetOS remplace tout ça.
        </p>
      </div>
    </section>;
}